/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Desktop_VersionsInputs */

const en_mk_desktop_versions = /** @type {(inputs: Mk_Desktop_VersionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Package versions and checksums`)
};

const id_mk_desktop_versions = /** @type {(inputs: Mk_Desktop_VersionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lihat versi paket dan checksum`)
};

/**
* | output |
* | --- |
* | "Package versions and checksums" |
*
* @param {Mk_Desktop_VersionsInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_desktop_versions = /** @type {((inputs?: Mk_Desktop_VersionsInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Desktop_VersionsInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_desktop_versions(inputs)
	return en_mk_desktop_versions(inputs)
});